import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);
const KEY = "digitalis-theme"; // 'system' | 'light' | 'dark'

function resolve(mode) {
  if (mode === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return mode;
}

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem(KEY) || "system");
  const [resolved, setResolved] = useState(() => resolve(localStorage.getItem(KEY) || "system"));

  const apply = useCallback((m) => {
    const r = resolve(m);
    setResolved(r);
    document.documentElement.classList.toggle("dark", r === "dark");
    document.documentElement.style.colorScheme = r;
  }, []);

  useEffect(() => { apply(mode); }, [mode, apply]);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => { if ((localStorage.getItem(KEY) || "system") === "system") apply("system"); };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [apply]);

  const setTheme = (m) => { localStorage.setItem(KEY, m); setMode(m); };

  return (
    <ThemeContext.Provider value={{ mode, resolved, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
